export const assignmentTitleArray = [
  { key: "1", label: "1" },
  { key: "2", label: "2" },
  { key: "3", label: "3" },
  { key: "Other", label: "Altro" },
];

export const personTypeArray = [
  { key: "PF", label: "Persona fisica" },
  { key: "PG", label: "Persona giuridica" },
];

export const languageTypeArray = [
  { key: "it", label: "Italiano" },
  {
    key: "en",
    label: "Inglese",
  },
];
